import styled from "@mui/material/styles/styled";

import Link from "@rui/Link";
import MenuItem from "@rui/MenuItem";

export const DownloadLink = styled(Link)(({ theme }) => ({
  fontWeight: 400,
  color: theme.palette.shades.neutral[800],
  padding: theme.spacing(1),
  display: "block",
  width: "100%",
}));

export const DownloadMenuItem = styled(MenuItem)({
  padding: 0,
});

export const DownloadButtonLink = styled(Link)(({ theme }) => ({
  ...theme.typography.bodyPrimaryReg,
  padding: theme.spacing(1.5),
  border: "1px solid",
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: theme.corners.base,
  color: theme.palette.shades.neutral[800],
  alignItems: "flex-start",
  justifyContent: "flex-start",
  "&:hover": {
    borderColor: theme.palette.shades.primary[500],
    backgroundColor: theme.palette.shades.ghost[500],
  },
}));
